import FormattedMessage from 'I18n/components/FormattedMessage';
import { Flex } from 'foundations-components/components/Flex';
import { Text } from 'foundations-components/components/Text';
import { Button } from 'foundations-components/transitional/components/Button';
import { AutocompleteItem } from './AutocompleteItem';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export function SearchGroupItem({
  item,
  keyword,
  onClick
}) {
  const label = item.resultType === 'CATEGORY' ? 'Category' : 'Collection';
  return /*#__PURE__*/_jsx(Button, {
    role: "button",
    "aria-label": `${item.term} ${label}`,
    use: "transparent",
    padding: "0",
    onClick: () => onClick === null || onClick === void 0 ? void 0 : onClick(item),
    children: /*#__PURE__*/_jsxs(Flex, {
      alignItems: "start",
      flexDirection: "column",
      children: [/*#__PURE__*/_jsx(AutocompleteItem, {
        keyword: keyword,
        suggestion: item.term
      }), /*#__PURE__*/_jsx(Text, {
        as: "small",
        color: "text-core-subtle",
        marginInlineStart: "1200",
        children: item.resultType === 'CATEGORY' ? /*#__PURE__*/_jsx(FormattedMessage, {
          message: 'marketplaceStorefront.searchBar.searchGroup.category'
        }) : /*#__PURE__*/_jsx(FormattedMessage, {
          message: 'marketplaceStorefront.searchBar.searchGroup.collection'
        })
      })]
    })
  });
}